import diamondUrl from '/web/icons/diamond.svg'

interface DiamondIconProps {
  size?: number
  class?: string
  style?: Record<string, string>
}

export function DiamondIcon(props: DiamondIconProps) {
  const size = () => props.size ?? 18
  return (
    <img
      src={diamondUrl}
      alt="VIP"
      class={props.class}
      style={{
        width: `${size()}px`,
        height: `${size()}px`,
        display: 'inline-block',
        'vertical-align': 'middle',
        'flex-shrink': '0',
        ...props.style,
      }}
    />
  )
}
